class TabWrapper extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    this.tabs = Array.from(this.container.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.container.querySelectorAll('[role="tabpanel"]'));
    if (!this.tabs.length) return;

    const tablist = this.container.querySelector(".product-calculator_tab-header");
    if (tablist && !tablist.getAttribute("role")) {
      tablist.setAttribute("role", "tablist");
      tablist.setAttribute("aria-label", "Order options");
    }

    this.tabs.forEach((tab, index) => {
      const panel = this.panels.find((p) => p.getAttribute("data-index") === tab.getAttribute("data-index"));
      const tabId = tab.id || `calculator-tab-${index}`;
      const panelId = panel?.id || `calculator-panel-${index}`;

      tab.id = tabId;
      tab.setAttribute("role", "tab");
      tab.setAttribute("aria-controls", panelId);
      if (panel) {
        panel.id = panelId;
        panel.setAttribute("role", "tabpanel");
        panel.setAttribute("aria-labelledby", tabId);
        panel.removeAttribute("tabindex");
      }

      tab.addEventListener("click", (e) => {
        this.activateTab(e.currentTarget);
      });

      tab.addEventListener("keydown", (e) => {
        const key = e.key;
        if (key === "Enter" || key === " ") {
          e.preventDefault();
          this.activateTab(tab);
          return;
        }
        if (key !== "ArrowRight" && key !== "ArrowLeft" && key !== "Home" && key !== "End") return;
        e.preventDefault();
        let nextIndex = this.tabs.indexOf(tab);
        if (key === "ArrowRight") nextIndex = (nextIndex + 1) % this.tabs.length;
        if (key === "ArrowLeft") nextIndex = (nextIndex - 1 + this.tabs.length) % this.tabs.length;
        if (key === "Home") nextIndex = 0;
        if (key === "End") nextIndex = this.tabs.length - 1;
        this.activateTab(this.tabs[nextIndex], true);
      });
    });

    const activeTab = this.tabs.find((tab) => tab.classList.contains("active")) || this.tabs[0];
    this.activateTab(activeTab, false);
  }

  activateTab(tab, focusTab = false) {
    if (!tab) return;
    const dataIndex = tab.getAttribute("data-index");

    this.tabs.forEach((item) => {
      const selected = item === tab;
      item.classList.toggle("active", selected);
      item.setAttribute("aria-selected", selected ? "true" : "false");
      item.setAttribute("tabindex", selected ? "0" : "-1");
    });

    this.panels.forEach((panel) => {
      const selected = panel.getAttribute("data-index") === dataIndex;
      panel.classList.toggle("active", selected);
      if (selected) {
        panel.removeAttribute("hidden");
      } else {
        panel.setAttribute("hidden", "");
      }
    });

    if (focusTab) tab.focus();
  }
}

customElements.define("tab-wrapper", TabWrapper);

class CalculatorVariants extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    if (this.container.querySelectorAll("calculator-select").length == 0) return;

    if (document.querySelectorAll("[data-inventories-json]").length > 0) {
      this.jsonData = JSON.parse(document.querySelector("[data-inventories-json]").innerHTML);
      this.variantsInventories = this.jsonData["inventories"] || {};
    } else {
      this.variantsInventories = {};
    }

    this.optionsSize = this.container.querySelectorAll("calculator-select").length;
    this.selectHandle();
  }

  selectHandle() {
    // Click option
    this.container.querySelectorAll(".js-calculator-option").forEach((calculatorOption) => {
      calculatorOption.addEventListener("click", (e) => {
        e.stopPropagation();

        if (e.currentTarget.classList.contains("active")) {
          return;
        }

        if (e.currentTarget.parentNode.querySelectorAll(".js-calculator-option.active").length > 0) {
          e.currentTarget.parentNode.querySelector(".js-calculator-option.active").classList.remove("active")
        }
        e.currentTarget.classList.add("active");

        this.selectElm = e.currentTarget.closest("calculator-select");
        this.labelElm = this.selectElm.querySelector(".js-calculator-label");
        this.dataValue = e.currentTarget.getAttribute("data-value");
        this.dataHTML = e.currentTarget.innerHTML;

        this.labelElm.setAttribute("data-value", this.dataValue);
        this.labelElm.querySelector(".js-calculator-label-text").innerHTML = this.dataHTML;
        this.labelElm.classList.remove("active");
        this.selectElm.classList.add("selected");
        e.currentTarget.parentNode.querySelectorAll(".js-calculator-option").forEach((item) => {
          item.setAttribute("aria-selected", String(item === e.currentTarget));
        });
        syncCalculatorSelectA11y(this.labelElm, false);
        if (typeof closeCalculatorSelects === "function") {
          closeCalculatorSelects();
        }

        // The total sq.ft should automatically revert to the default value
        document.querySelector(".js-product-calculator-input").value = "";

        if (e.currentTarget.classList.contains("js-calculator-bullnose")) {
          this.selectElm.setAttribute("data-bullnose", e.currentTarget.getAttribute("data-bullnose"));
        }

        if (this.container.querySelectorAll("calculator-select.selected").length == this.optionsSize) {
          this.container.classList.add("select-done");
          document.querySelector(".js-select-option-warning").style.display = "none";

          this.updateOptions();
          this.updateMasterId();

          const calculatorAtc = document.querySelector("calculator-atc");

          if (this.currentVariant) {
            this.updateMedia();

            this.metafieldsData = JSON.parse(this.querySelector('.VariantMetafieldsJson[data-id="' + this.currentVariant.id + '"]').textContent);
            if (this.metafieldsData) {
              this.updateMetafields();
            }
            this.updateInventoryQuantity();
            window.calProductVariant = this.currentVariant;
            calculatorAtc.updateButton(true);
          } else {
            window.calProductVariant = 'unavailable';
            calculatorAtc.updateButton(true);
          }
        } else {
          this.container.classList.remove("select-done");
          document.querySelector(".js-select-option-warning").style.display = "block";
        }
      });
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateInventoryQuantity() {
    if (document.querySelectorAll(".js-product-calculator-atc").length > 0) {
      if (this.currentVariant.inventory_management == "shopify") {
        this.variantInventory = this.variantsInventories[this.currentVariant.id];
        this.inventoryQuantity = this.variantInventory["inventory_quantity"];

        document.querySelector(".js-product-calculator-atc").setAttribute("data-track-quantity", "shopify");
        document.querySelector(".js-product-calculator-atc").setAttribute("data-inventory-quantity", this.inventoryQuantity);
        document.querySelector(".js-product-calculator-atc").setAttribute("data-inventory-policy", this.variantInventory["inventory_policy"]);
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll(".js-calculator-label-text"), (element) => {
      return element.textContent.trim();
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMetafields() {
    window.metafieldsData = this.metafieldsData;
    // Update note
    if (document.querySelectorAll(".js-product-calculator-note").length > 0) {
      this.calculatorNoteElm = document.querySelector(".js-product-calculator-note");
      if (window.metafieldsData.noteHeader != "") {
        this.productNoteHeader = window.metafieldsData.noteHeader;
      } else {
        this.productNoteHeader = window.calculatorDefaultTexts.productNoteHeader;
      }

      if (window.metafieldsData.noteContent != "") {
        this.productNoteContent = window.metafieldsData.noteContent;
      } else {
        this.productNoteContent = window.calculatorDefaultTexts.productNoteContent;
      }

      this.calculatorNoteElm.querySelector(".product-calculator_note-header-text").textContent = this.productNoteHeader;
      this.calculatorNoteElm.querySelector(".product-calculator_note-content").textContent = this.productNoteContent;
      document.querySelector(".js-product-calculator-note").style.display = "block";
    }

    // Update price
    if (document.querySelectorAll(".js-calculator-pricePerPc").length > 0) {
      document.querySelector(".js-calculator-pricePerPc").innerHTML = Shopify.formatMoney(this.metafieldsData.pricePerPc * 100);
    }
    if (window.actualPercentage < 1 && document.querySelectorAll(".js-calculator-pricePerPc-sale").length > 0) {
      document.querySelector(".js-calculator-pricePerPc-sale").innerHTML = Shopify.formatMoney(
        this.metafieldsData.pricePerPc * 100 * window.actualPercentage
      );
    }

    this.methodValue = document.querySelector("calculator-result").getAttribute("data-method");
    if (this.methodValue == "c1") {
      this.pricePerArea = window.metafieldsData.pricePerSq * 100;
      this.areaPerBox = window.metafieldsData.sqPerBox;
    } else {
      this.pricePerArea = window.metafieldsData.pricePerLi * 100;
      this.areaPerBox = window.metafieldsData.liPerBox;
    }

    if (document.querySelectorAll(".js-calculator-pricePerSq").length > 0) {
      document.querySelector(".js-calculator-pricePerSq").innerHTML = Shopify.formatMoney(this.pricePerArea);
    }
    if (window.actualPercentage < 1 && document.querySelectorAll(".js-calculator-pricePerSq-sale").length > 0) {
      document.querySelector(".js-calculator-pricePerSq-sale").innerHTML = Shopify.formatMoney(this.pricePerArea * window.actualPercentage);
    }

    if (document.querySelectorAll(".js-calculator-areaBox").length > 0) {
      document.querySelector(".js-calculator-areaBox").textContent = this.areaPerBox;
    }

    if (document.querySelectorAll(".js-calculator-pricePerBox").length > 0) {
      document.querySelector(".js-calculator-pricePerBox").innerHTML = Shopify.formatMoney(this.metafieldsData.pricePerBox * 100);
    }
    if (window.actualPercentage < 1 && document.querySelectorAll(".js-calculator-pricePerBox-sale").length > 0) {
      document.querySelector(".js-calculator-pricePerBox-sale").innerHTML = Shopify.formatMoney(
        this.metafieldsData.pricePerBox * 100 * window.actualPercentage
      );
    }

    if (document.querySelectorAll(".js-calculator-total-price").length > 0) {
      document.querySelector(".js-calculator-total-price").setAttribute("data-price", this.metafieldsData.pricePerPc * 100 * window.actualPercentage);
    }

    if (document.querySelectorAll(".js-calculator-total-price-regular").length > 0) {
      document.querySelector(".js-calculator-total-price-regular").setAttribute("data-price-regular", this.metafieldsData.pricePerPc * 100);
    }

    // Update form
    if (document.querySelectorAll(".js-product-calculator-variant").length > 0) {
      document.querySelector(".js-product-calculator-variant").value = this.currentVariant.id;
    }
    if (document.querySelectorAll('.js-properties-noteHeader').length > 0) {
      document.querySelector('.js-properties-noteHeader').value = this.productNoteHeader;
    }
    if (document.querySelectorAll('[name="properties[_sqPerBox]"]').length > 0) {
      document.querySelector('[name="properties[_sqPerBox]"]').value = this.calculationMethodText;
    }

    this.pcsPerBox = parseInt(this.metafieldsData.pcsPerBox, 10);
    let qtyMin = Math.ceil(this.pcsPerBox / window.patternsBundle);
    if (window.productSettings.sellingIn == "box") {
      if (document.querySelectorAll('[name="properties[_pcsPerBox]"]').length > 0) {
        document.querySelector('[name="properties[_pcsPerBox]"]').value = this.pcsPerBox;
      }
    }

    if (document.querySelectorAll('[name="properties[_qtyMin]"]').length > 0) {
      document.querySelector('[name="properties[_qtyMin]"]').value = qtyMin;
    }

    // Re-calculator
    // if (
    //   document.querySelectorAll(".product-calculator_input-wrap.selected").length ==
    //   document.querySelectorAll(".product-calculator_input-wrap.active").length &&
    //   document.querySelectorAll("calculator-result").length > 0
    // ) {
    //   const calculatorResult = document.querySelector("calculator-result");
    //   calculatorResult.calculator(true);
    // }

    document.querySelector(".js-product-calculator-price").style.display = "flex";
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector("#ProductVariantJson").textContent);
    return this.variantData;
  }
}

customElements.define("calculator-variants", CalculatorVariants);

class CalculatorResult extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    this.overage = parseInt(this.container.querySelector('.js-product-calculator-select.active[data-type="overage"]').getAttribute('data-value'), 10);
    this.inputHandle();
  }

  inputHandle() {
    this.container.querySelector(".js-product-calculator-input").addEventListener("keyup", debounce((e) => {
      const calculatorAtc = document.querySelector("calculator-atc");
      calculatorAtc.loading(true);

      this.onChange(e);
    }, 500).bind(this));

    this.container.querySelectorAll(".js-product-calculator-select").forEach((select) => {
      select.addEventListener("click", (e) => {
        e.stopPropagation();

        this.selectElm = e.currentTarget.closest("calculator-properties");
        this.labelElm = this.selectElm.querySelector(".js-calculator-label");
        this.labelElm.classList.remove("active");
        syncCalculatorSelectA11y(this.labelElm, false);

        if (!e.currentTarget.classList.contains("active")) {
          if (e.currentTarget.getAttribute("data-type") == "overage") {
            this.overage = parseInt(e.currentTarget.getAttribute("data-value"), 10);

            if (this.overage == 0) {
              document.querySelector(".js-overage-warning").style.display = "block";
            } else {
              document.querySelector(".js-overage-warning").style.display = "none";
            }
          } else if (e.currentTarget.getAttribute("data-type") == "unit") {
            // Select unit
            this.methodValue = e.currentTarget.getAttribute("data-value");
            this.container.setAttribute("data-method", this.methodValue);
            this.methodText = e.currentTarget.innerHTML;

            e.currentTarget.closest(".product-calculator_input-wrap").classList.add("selected");
            e.currentTarget.closest(".product-calculator__select").classList.add("selected");

            // if (this.methodValue == "c2") {
            //   document.querySelector(".js-product-calculator-bullnose").classList.add("active");
            // } else if (document.querySelectorAll(".js-product-calculator-bullnose").length > 0) {
            //   document.querySelector(".js-product-calculator-bullnose").classList.remove("active");
            // }

            this.changeUnit();
          }

          this.labelElm.querySelector("div").innerHTML = e.currentTarget.innerHTML;
          if (this.selectElm.querySelectorAll(".js-product-calculator-select.active").length > 0) {
            this.selectElm.querySelector(".js-product-calculator-select.active").classList.remove("active");
          }
          e.currentTarget.classList.add("active");

          if (
            document.querySelectorAll(".product-calculator_input-wrap.selected").length ==
            document.querySelectorAll(".product-calculator_input-wrap.active").length
          ) {
            // Check if there is variant
            if (document.querySelectorAll("calculator-variants").length > 0) {
              // Check if variant is selected
              if (document.querySelector("calculator-variants").classList.contains("select-done")) {
                this.calculator();
              }
            } else {
              this.calculator();
            }
          }
        }
      });
    });
  }

  onChange(e) {
    this.sqftNeeded = parseInt(e.target.value, 10);

    if (isNaN(this.sqftNeeded)) {
      e.target.parentNode.classList.remove("selected");
    } else {
      e.target.parentNode.classList.add("selected");
    }

    if (
      document.querySelectorAll(".product-calculator_input-wrap.selected").length == document.querySelectorAll(".product-calculator_input-wrap.active").length
    ) {
      this.calculator();
    } else {
      document.querySelector(".js-product-calculator-result").style.display = "none";
    }
  }

  changeUnit() {
    if (this.methodValue == "c1") {
      this.pricePerArea = window.metafieldsData.pricePerSq * 100;
      this.areaPerBox = window.metafieldsData.sqPerBox;

      if (document.querySelectorAll(".js-calculator-areaBox").length > 0) {
        document.querySelector(".js-calculator-areaBox").textContent = this.areaPerBox;
      }
      if (document.querySelectorAll(".js-calculator-sqftPerBox").length > 0) {
        document.querySelector(".js-calculator-sqftPerBox").style.display = "block";
      }
    } else {
      this.pricePerArea = window.metafieldsData.pricePerLi * 100;
      // this.areaPerBox = window.metafieldsData.liPerBox;
      if (document.querySelectorAll(".js-calculator-sqftPerBox").length > 0) {
        document.querySelector(".js-calculator-sqftPerBox").style.display = "none";
      }
    }

    if (document.querySelectorAll(".js-calculator-pricePerSq").length > 0) {
      document.querySelector(".js-calculator-pricePerSq").innerHTML = Shopify.formatMoney(this.pricePerArea);
    }
    if (window.actualPercentage < 1 && document.querySelectorAll(".js-calculator-pricePerSq-sale").length > 0) {
      document.querySelector(".js-calculator-pricePerSq-sale").innerHTML = Shopify.formatMoney(this.pricePerArea * window.actualPercentage);
    }

    document.querySelectorAll(".js-method-name").forEach((elm) => {
      elm.textContent = this.methodText;
      // if (this.methodText == "linear ft" && elm.classList.contains("js-method-short-name")) {
      //   elm.textContent = "LF";
      // }
    });
  }

  calculator(firstLoad) {
    if (this.container.querySelector('.js-product-calculator-input[data-type="sqft"]').value != "" && this.container.querySelector('.js-product-calculator-input[data-type="sqft"]').value != '0') {
      if (document.querySelectorAll("calculator-variants").length > 0) {
        let optionsSize = document.querySelectorAll("calculator-variants calculator-select").length;
        if (document.querySelectorAll("calculator-select.selected").length != optionsSize) {
          return;
        }
      }

      if (firstLoad) {
        this.sqftNeeded = parseInt(this.container.querySelector('.js-product-calculator-input[data-type="sqft"]').value, 10);
        this.overage = parseInt(this.container.querySelector('.js-product-calculator-select.active[data-type="overage"]').getAttribute('data-value'), 10);
      }

      this.calculatorMethod = this.container.getAttribute("data-method");

      this.pcsPerBox = parseInt(window.metafieldsData.pcsPerBox, 10);
      this.buttonSubmit = document.querySelector(".js-product-calculator-atc");

      this.sqftOverage = (this.sqftNeeded * this.overage) / 100;
      this.sqftNeededTotal = this.sqftNeeded + this.sqftOverage;

      if (this.calculatorMethod == "c1") {
        this.calculationMethodText = "SQ.FT";

        this.tileSize = 1 / parseFloat(window.metafieldsData.pcsPerSq);
        this.totalPieces = Math.ceil(this.sqftNeededTotal / this.tileSize);
      } else {
        this.calculationMethodText = "LF";

        this.tileSize = 1 / parseFloat(window.metafieldsData.pcsPerLi);

        // this.bullnose = this.container.querySelector("#product-calculator_input-bullnose").value;
        this.bullnose = "short";
        if (document.querySelectorAll(".product-calculator__select-bullnose").length > 0) {
          this.bullnose = document.querySelector(".product-calculator__select-bullnose").getAttribute("data-bullnose");
        } else if (document.querySelectorAll(".product-calculator__select-size .js-calculator-label-text").length > 0) {
          this.optionSize = document.querySelector(".product-calculator__select-size .js-calculator-label-text").textContent.replace(/\D/g, "");
          this.optionSizeNumber = parseFloat(this.optionSize);
          this.tileLength = parseFloat(window.metafieldsData.length);
          if (this.optionSizeNumber == this.tileLength) {
            this.bullnose = "long";
          }
        }

        this.linToInches = 12;
        if (this.bullnose == "short") {
          this.pcsPerLin = this.linToInches / parseFloat(window.metafieldsData.width);
          this.tileSize = window.metafieldsData.width;
        } else {
          this.pcsPerLin = this.linToInches / parseFloat(window.metafieldsData.length);
          this.tileSize = window.metafieldsData.length;
        }
        this.totalPieces = Math.ceil(this.pcsPerLin * this.sqftNeededTotal);
      }

      // if (window.productSettings.sellingIn == 'box') {
      this.totalBox = Math.ceil(this.totalPieces / this.pcsPerBox);
      this.boxToPieces = this.totalBox * this.pcsPerBox;
      // } else {
      //   this.boxToPieces = this.totalPieces;
      // }

      this.quantity = Math.ceil(this.boxToPieces / window.patternsBundle);

      // Update again when calculating the number of bundles needed
      this.totalSqft = (this.quantity * window.patternsBundle * this.tileSize).toFixed(2);
      if (this.calculatorMethod == "c2") {
        this.totalSqft = (this.totalSqft / 12).toFixed(2);
      }
      // if (window.productSettings.sellingIn == 'pieces') {
      //   this.boxToPieces = this.quantity * window.patternsBundle;
      // }

      // Update result
      if (document.querySelectorAll(".js-calculator-totalBox").length > 0) {
        document.querySelector(".js-calculator-totalBox").textContent = this.totalBox;
      }
      if (document.querySelectorAll(".js-calculator-boxText").length > 0) {
        document.querySelector(".js-calculator-boxText").textContent = this.totalBox > 1 ? "Boxes" : "Box";
      }
      if (document.querySelectorAll(".js-calculator-totalPcs").length > 0) {
        document.querySelector(".js-calculator-totalPcs").textContent = this.quantity;
      }
      if (document.querySelectorAll(".js-calculator-totalSqft").length > 0) {
        document.querySelector(".js-calculator-totalSqft").textContent = this.totalSqft;
      }
      if (document.querySelectorAll(".js-calculator-total-price-regular").length > 0) {
        this.totalPriceRegularElm = document.querySelector(".js-calculator-total-price-regular");
        this.priceRegularPerPc = parseFloat(this.totalPriceRegularElm.getAttribute("data-price-regular"));
        this.totalPriceRegularElm.innerHTML = Shopify.formatMoney(this.quantity * window.patternsBundle * this.priceRegularPerPc);
      }
      if (document.querySelectorAll(".js-calculator-total-price").length > 0) {
        this.totalPriceElm = document.querySelector(".js-calculator-total-price");
        this.pricePerPc = parseFloat(this.totalPriceElm.getAttribute("data-price"));
        this.totalPriceElm.innerHTML = Shopify.formatMoney(this.quantity * window.patternsBundle * this.pricePerPc);
      }

      this.announceCalculatorResult();

      // Update form
      if (document.querySelectorAll('[name="properties[_areaPiece]"]').length > 0) {
        if (this.calculatorMethod == "c2") {
          this.tileSize = (this.tileSize / 12).toFixed(10);
        }
        document.querySelector('[name="properties[_areaPiece]"]').value = this.tileSize;
      }
      if (document.querySelectorAll(".js-product-calculator-quantity").length > 0) {
        document.querySelector(".js-product-calculator-quantity").value = this.quantity;
      }
      // if (document.querySelectorAll('[name="properties[total]"]').length > 0) {
      //   this.totalText = this.totalSqft + ' ' + this.calculationMethodText;
      //   if (window.productSettings.sellingIn == 'box') {
      //     this.totalText += ' | ' + this.totalBox + ' box';
      //   }
      //   document.querySelector('[name="properties[total]"]').value = this.totalText;
      // }
      if (document.querySelectorAll('[name="properties[_calculationMethodText]"]').length > 0) {
        document.querySelector('[name="properties[_calculationMethodText]"]').value = this.calculationMethodText;
      }

      // Update button ATC
      this.buttonSubmit.setAttribute("data-pieces-needed", this.totalPieces);
      this.buttonSubmit.setAttribute("data-total-pieces", this.boxToPieces);
      this.buttonSubmit.setAttribute("data-quantity", this.quantity);

      const calculatorAtc = document.querySelector("calculator-atc");
      calculatorAtc.updateButton(false);
    } else {
      document.querySelector(".js-product-calculator-result").style.display = "none";
      const liveStatus = document.getElementById("product-calculator-live-status");
      if (liveStatus) liveStatus.textContent = "";
    }
  }

  announceCalculatorResult() {
    const liveStatus = document.getElementById("product-calculator-live-status");
    if (!liveStatus) return;

    const parts = [];
    const boxes = document.querySelector(".js-calculator-totalBox")?.textContent?.trim();
    const boxText = document.querySelector(".js-calculator-boxText")?.textContent?.trim() || "boxes";
    const pieces = document.querySelector(".js-calculator-totalPcs")?.textContent?.trim();
    const area = document.querySelector(".js-calculator-totalSqft")?.textContent?.trim();
    const method = document.querySelector(".js-product-calculator-result .js-method-name")?.textContent?.trim() || "sq.ft";
    const total = document.querySelector(".js-calculator-total-price")?.textContent?.trim();

    if (boxes) parts.push(`${boxes} ${boxText}`);
    if (pieces) parts.push(`${pieces} total pieces`);
    if (area) parts.push(`${area} total ${method}`);
    if (total) parts.push(`Total ${total}`);

    liveStatus.textContent = parts.length ? `Calculator updated: ${parts.join(", ")}.` : "";
  }
}

customElements.define("calculator-result", CalculatorResult);

class CalculatorAtc extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("button");
  }

  async updateButton(isChangeVariant) {
    let variantAvailable = window.calProductVariant.available;
    
    if (isChangeVariant) {
      // when changing variant
      if (variantAvailable) {
        this.button.querySelector(".js-product-calculator-atc-text").textContent = window.variantStrings.addToCart;
        this.button.removeAttribute("disabled");
      } else {
        if (window.calProductVariant == 'unavailable') {
          this.button.querySelector(".js-product-calculator-atc-text").textContent = window.variantStrings.unavailable;
          this.button.setAttribute("disabled", "disabled");
        } else {
          this.button.querySelector(".js-product-calculator-atc-text").textContent = window.variantStrings.onBackOrder;
          this.button.setAttribute("disabled", "disabled");
        }
      }

      if (document.querySelectorAll(".js-product-calculator-note").length > 0) {
        document.querySelector(".js-product-calculator-note").style.display = "none";
      }
      document.querySelector(".js-product-calculator-result").style.display = "none";
    } else {
      // when calculating
      this.checkInventoryWarning = false;
      if (this.button.getAttribute("data-track-quantity") === "shopify" && variantAvailable) {
        this.inventoryQuantity = parseInt(this.button.getAttribute("data-inventory-quantity"), 10);
        this.totalPieces = parseInt(this.button.getAttribute("data-quantity"), 10);
        
        let variantId = window.calProductVariant.id;
        this.variantInCart = 0;
        this.cartItems = await fetch("/cart.js");
        this.cartItems = await this.cartItems.json();
        this.cartItems.items.map((item) => {
          if (item.variant_id == variantId) {
            this.variantInCart += item.quantity;
          }
        });

        this.remainingInventory = this.inventoryQuantity - this.variantInCart;

        this.button.setAttribute("data-remaining-inventory", this.remainingInventory);
        this.button.setAttribute("data-total-pieces", this.totalPieces);
        document.dispatchEvent(new CustomEvent("backorderCheck"));
 
        console.log('variantInCart: ', this.variantInCart);
        console.log('remainingInventory: ', this.remainingInventory);
        console.log('totalPieces: ', this.totalPieces);
        
        if (this.totalPieces > this.remainingInventory) {
          if (this.button.getAttribute("data-inventory-policy") == "continue") {
            this.button.querySelector(".js-product-calculator-atc-text").textContent = window.variantStrings.addToCart;
            this.button.removeAttribute("disabled");
            if (this.inventoryQuantity > 0) {
              if (window.metafieldsData.inventoryWarning != "") {
                this.inventoryWarningText = window.metafieldsData.inventoryWarning;
              } else {
                this.inventoryWarningText = window.calculatorDefaultTexts.inventoryWarning;
              }

              document.querySelector(".js-product-calculator_inventory-warning").textContent = this.inventoryWarningText;
              this.checkInventoryWarning = true;
            } else {
              document.querySelector(".js-product-calculator_inventory-warning").textContent = "";
            }
          } else {
            this.button.querySelector(".js-product-calculator-atc-text").textContent = window.variantStrings.onBackOrder;
            this.button.setAttribute("disabled", "disabled");

            document.querySelector(".js-product-calculator_inventory-warning").textContent = "";
          }
        } else {
          this.button.querySelector(".js-product-calculator-atc-text").textContent = window.variantStrings.addToCart;
          this.button.removeAttribute("disabled");
          document.querySelector(".js-product-calculator_inventory-warning").textContent = "";
        }
      }

      if (this.checkInventoryWarning && document.querySelector(".js-product-calculator_inventory-warning").getAttribute("data-warning") === "true") {
        if (document.querySelectorAll(".js-product-calculator-note").length > 0) {
          document.querySelector(".js-product-calculator-note").style.display = "none";
        }
        if (document.querySelectorAll('.js-properties-noteHeader').length > 0) {
          document.querySelector('.js-properties-noteHeader').value = this.inventoryWarningText;
        }
      } else {
        if (document.querySelectorAll(".js-product-calculator-note").length > 0) {
          document.querySelector(".js-product-calculator-note").style.display = "block";
        }
        if (document.querySelectorAll('.js-properties-noteHeader').length > 0) {
          if (window.metafieldsData.noteHeader != "") {
            this.productNoteHeader = window.metafieldsData.noteHeader;
          } else {
            this.productNoteHeader = window.calculatorDefaultTexts.productNoteHeader;
          }
          document.querySelector('.js-properties-noteHeader').value = this.productNoteHeader;
        }
      }

      document.querySelector(".js-product-calculator-result").style.display = "flex";
      document.dispatchEvent(new CustomEvent("backorderCheck"));

      this.loading(false);
    }
  }

  loading(isLoading) {
    if (isLoading) {
      this.button.setAttribute("aria-disabled", true);
      this.button.classList.add("loading");
      this.querySelector(".loading__spinner").classList.remove("hidden");
    } else {
      this.button.removeAttribute("aria-disabled");
      this.button.classList.remove("loading");
      this.querySelector(".loading__spinner").classList.add("hidden");
    }
  }
}

customElements.define("calculator-atc", CalculatorAtc);

class SampleProduct extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    this.buttonSubmit = this.container.querySelector("button");
    if (!this.buttonSubmit) return;

    this.container.querySelectorAll(".js-calculator-option").forEach((sampleOption) => {
      sampleOption.addEventListener("click", (e) => {
        e.stopPropagation();

        this.selectElm = e.currentTarget.closest("sample-select");
        this.labelElm = this.selectElm.querySelector(".js-calculator-label");
        this.dataValue = e.currentTarget.getAttribute("data-value");
        this.dataHTML = e.currentTarget.innerHTML;
        this.dataName = e.currentTarget.getAttribute("data-name");

        this.labelElm.setAttribute("data-value", this.dataValue);
        this.labelElm.querySelector("div").innerHTML = this.dataHTML;
        this.labelElm.classList.remove("active");
        this.selectElm.classList.add("selected");
        e.currentTarget.parentNode.querySelectorAll(".js-calculator-option").forEach((item) => {
          item.setAttribute("aria-selected", String(item === e.currentTarget));
        });
        syncCalculatorSelectA11y(this.labelElm, false);
        if (typeof closeCalculatorSelects === "function") {
          closeCalculatorSelects();
        }
        if (this.container.querySelectorAll('[name="' + this.dataName + '"]').length > 0) {
          this.container.querySelector('[name="' + this.dataName + '"]').value = this.dataValue;
        }

        if (document.querySelectorAll("sample-select.selected").length == document.querySelectorAll("sample-select.active").length) {
          this.buttonSubmit.removeAttribute("disabled");
        }
      });
    });

    // this.container.querySelectorAll(".js-product-sample-select").forEach((select) => {
    //   select.addEventListener("change", (e) => {
    //     e.currentTarget.parentNode.classList.add("selected");

    //     if (document.querySelectorAll(".product-sample_input-wrap.selected").length == document.querySelectorAll(".product-sample_input-wrap.active").length) {
    //       this.buttonSubmit.removeAttribute("disabled");
    //     }
    //   });
    // });
  }
}

customElements.define("sample-product", SampleProduct);

function getCalculatorSelectOptions(label) {
  return Array.from(
    label?.nextElementSibling?.querySelectorAll(".js-product-calculator-select, .js-calculator-option") || []
  );
}

function syncCalculatorSelectA11y(label, isOpen, activeOption) {
  if (!label) return;
  label.setAttribute("aria-expanded", isOpen ? "true" : "false");
  const options = getCalculatorSelectOptions(label);
  options.forEach((option, index) => {
    if (!option.id) option.id = `${label.id || "calculator-select"}-option-${index}`;
    option.tabIndex = -1;
    option.classList.toggle("is-keyboard-active", false);
  });

  if (!isOpen) {
    label.removeAttribute("aria-activedescendant");
    return;
  }

  const selected =
    activeOption ||
    options.find((option) => option.getAttribute("aria-selected") === "true") ||
    options.find((option) => option.classList.contains("active")) ||
    options[0];

  if (!selected) return;
  selected.classList.add("is-keyboard-active");
  label.setAttribute("aria-activedescendant", selected.id);
}

function closeCalculatorSelects(exceptLabel) {
  document.querySelectorAll(".js-calculator-label.active").forEach((label) => {
    if (label === exceptLabel) return;
    label.classList.remove("active");
    syncCalculatorSelectA11y(label, false);
  });
}

function moveCalculatorSelectOption(label, direction) {
  const options = getCalculatorSelectOptions(label);
  if (!options.length) return;

  const currentId = label.getAttribute("aria-activedescendant");
  let index = options.findIndex((option) => option.id === currentId);
  if (index < 0) {
    index = options.findIndex((option) => option.classList.contains("active") || option.getAttribute("aria-selected") === "true");
  }
  if (index < 0) index = 0;

  const nextIndex = direction === "down"
    ? (index + 1) % options.length
    : (index - 1 + options.length) % options.length;

  syncCalculatorSelectA11y(label, true, options[nextIndex]);
  options[nextIndex].scrollIntoView({ block: "nearest" });
}

function commitCalculatorSelectOption(label) {
  const options = getCalculatorSelectOptions(label);
  const currentId = label.getAttribute("aria-activedescendant");
  const active =
    options.find((option) => option.id === currentId) ||
    options.find((option) => option.classList.contains("is-keyboard-active")) ||
    options.find((option) => option.classList.contains("active"));

  if (!active) return;
  active.click();
  options.forEach((item) => {
    item.setAttribute("aria-selected", String(item === active));
  });
  label.classList.remove("active");
  syncCalculatorSelectA11y(label, false);
  closeCalculatorSelects();
  label.focus();
}

function openCalculatorSelect(label) {
  closeCalculatorSelects(label);
  label.classList.add("active");
  syncCalculatorSelectA11y(label, true);
  label.focus();
}

function toggleCalculatorSelect(label) {
  if (label.classList.contains("active")) {
    closeCalculatorSelects();
    label.focus();
    return;
  }
  openCalculatorSelect(label);
}

window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".js-calculator-label").forEach((label) => {
    if (!label.hasAttribute("tabindex")) label.setAttribute("tabindex", "0");
    if (!label.id) {
      const type = label.nextElementSibling?.querySelector(".js-product-calculator-select")?.getAttribute("data-type");
      label.id = type ? `product-calculator_${type}-button` : `calculator-label-${Math.random().toString(36).slice(2, 8)}`;
    }
    if (!label.getAttribute("role")) label.setAttribute("role", "combobox");
    if (!label.hasAttribute("aria-haspopup")) label.setAttribute("aria-haspopup", "listbox");
    syncCalculatorSelectA11y(label, false);

    label.addEventListener("click", (e) => {
      e.stopPropagation();
      toggleCalculatorSelect(label);
    });

    label.addEventListener("keydown", (event) => {
      const isOpen = label.classList.contains("active");

      if (event.key === "Escape") {
        if (!isOpen) return;
        event.preventDefault();
        closeCalculatorSelects();
        label.focus();
        return;
      }

      if (event.key === "ArrowDown") {
        event.preventDefault();
        if (!isOpen) openCalculatorSelect(label);
        else moveCalculatorSelectOption(label, "down");
        return;
      }

      if (event.key === "ArrowUp") {
        event.preventDefault();
        if (!isOpen) openCalculatorSelect(label);
        else moveCalculatorSelectOption(label, "up");
        return;
      }

      if (event.key === "Home" && isOpen) {
        event.preventDefault();
        const options = getCalculatorSelectOptions(label);
        if (options[0]) syncCalculatorSelectA11y(label, true, options[0]);
        return;
      }

      if (event.key === "End" && isOpen) {
        event.preventDefault();
        const options = getCalculatorSelectOptions(label);
        if (options.length) syncCalculatorSelectA11y(label, true, options[options.length - 1]);
        return;
      }

      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        if (isOpen) commitCalculatorSelectOption(label);
        else openCalculatorSelect(label);
      }
    });
  });

  document.querySelectorAll(".js-product-calculator-select").forEach((option) => {
    option.addEventListener("keydown", (event) => {
      const label = option.closest("calculator-properties")?.querySelector(".js-calculator-label");
      if (!label) return;

      if (event.key === "ArrowDown" || event.key === "ArrowUp") {
        event.preventDefault();
        label.focus();
        if (!label.classList.contains("active")) openCalculatorSelect(label);
        moveCalculatorSelectOption(label, event.key === "ArrowDown" ? "down" : "up");
        return;
      }
      if (event.key === "Escape") {
        event.preventDefault();
        closeCalculatorSelects();
        label.focus();
        return;
      }
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      option.click();
      option.parentNode.querySelectorAll(".js-product-calculator-select").forEach((item) => {
        item.setAttribute("aria-selected", String(item === option));
      });
      closeCalculatorSelects();
      label.focus();
    });
  });
});

window.addEventListener("click", (event) => {
  if (event.target.closest(".js-calculator-label, .product-calculator__select-option")) return;
  closeCalculatorSelects();
});
window.addEventListener("pageshow", () => {
  // if (document.querySelectorAll(".js-product-calculator-select").length > 0) {
  //   document.querySelectorAll(".js-product-calculator-select").forEach((select) => {
  //     if (select.value != "") {
  //       select.parentNode.classList.add("selected");
  //     }
  //     if (select.getAttribute("data-type") == "unit") {
  //       if (document.querySelector("calculator-result").getAttribute("data-method") == "c2") {
  //         document.querySelector(".js-product-calculator-bullnose").classList.add("active");
  //       } else if (document.querySelectorAll(".js-product-calculator-bullnose").length > 0) {
  //         document.querySelector(".js-product-calculator-bullnose").classList.remove("active");
  //       }
  //     }
  //   });
  // }

  if (document.querySelectorAll(".js-product-calculator-input").length > 0) {
    document.querySelectorAll(".js-product-calculator-input").forEach((input) => {
      if (input.value != "") {
        input.parentNode.classList.add("selected");
      }
    });
  }

  if (
    document.querySelectorAll(".product-calculator_input-wrap.selected").length == document.querySelectorAll(".product-calculator_input-wrap.active").length &&
    document.querySelectorAll("calculator-result").length > 0
  ) {
    const calculatorResult = document.querySelector("calculator-result");
    calculatorResult.calculator(true);
  }
});
